import { defaultStatus } from "../../screen/constant/defaultStatus";
import {
  REPORT_WHOLESALER_REPORT_BYID_FAILURE,
  REPORT_WHOLESALER_REPORT_BYID_REQUEST,
  REPORT_WHOLESALER_REPORT_BYID_SUCCESS,
  REPORT_WHOLESALER_REPORT_BYID_SEARCH_REQUEST,
  REPORT_WHOLESALER_REPORT_BYID_SEARCH_SUCCESS,
  REPORT_WHOLESALER_REPORT_BYID_SEARCH_FAILURE,
  WHOLESALER_REPORT_BYID_DATE_SEARCH_REQUEST,
  WHOLESALER_REPORT_BYID_DATE_SEARCH_SUCCESS,
  WHOLESALER_REPORT_BYID_DATE_SEARCH_FAILURE,
  REPORT_WHOLESALER_MONTH_REPORT_BYID_REQUEST,
  REPORT_WHOLESALER_MONTH_REPORT_BYID_SUCCESS,
  REPORT_WHOLESALER_MONTH_REPORT_BYID_FAILURE,
  REPORT_WHOLESALER_WEEK_REPORT_BYID_REQUEST,
  REPORT_WHOLESALER_WEEK_REPORT_BYID_SUCCESS,
  REPORT_WHOLESALER_WEEK_REPORT_BYID_FAILURE,
  WHOLESALER_REPORT_MONTH_BYID_DATE_SEARCH_REQUEST,
  WHOLESALER_REPORT_MONTH_BYID_DATE_SEARCH_SUCCESS,
  WHOLESALER_REPORT_MONTH_BYID_DATE_SEARCH_FAILURE,
  WHOLESALER_REPORT_WEEK_BYID_DATE_SEARCH_REQUEST,
  WHOLESALER_REPORT_WEEK_BYID_DATE_SEARCH_SUCCESS,
  WHOLESALER_REPORT_WEEK_BYID_DATE_SEARCH_FAILURE,
  WHOLESALER_REPORT_MONTH_BYID_DATE_SEARCH_RESET,
  WHOLESALER_REPORT_WEEK_BYID_DATE_SEARCH_RESET,
  WHOLESALER_REPORT_BYID_DATE_SEARCH_RESET,
} from "./WholesalerReportByIdTypes";

const initialState = {
  monthWholesalerReportsById: { ...defaultStatus },
  WeekWholesalerReportsById: { ...defaultStatus },
  monthDateSearchWholesalerReportsById: { ...defaultStatus },
  weekDateSearchWholesalerReportsById: { ...defaultStatus },
  viewAllWholesalerReportsById: { ...defaultStatus },
  searchWholesalerReportsById: { ...defaultStatus },
  dateSearchWholesalerReportsById: { ...defaultStatus },
};

export default function reportReducer(state = initialState, action) {
  const { type, payload } = action;

  switch (type) {
    //Wholesaler Month Report By Id
    case REPORT_WHOLESALER_MONTH_REPORT_BYID_REQUEST:
      return {
        ...state,
        monthWholesalerReportsById: {
          ...defaultStatus,
          inProgress: true,
          ...payload,
        },
      };
    case REPORT_WHOLESALER_MONTH_REPORT_BYID_SUCCESS:
      return {
        ...state,
        monthWholesalerReportsById: {
          ...defaultStatus,
          success: true,
          data: payload,
        },
      };
    case REPORT_WHOLESALER_MONTH_REPORT_BYID_FAILURE:
      return {
        ...state,
        monthWholesalerReportsById: {
          ...defaultStatus,
          error: true,
          errormessage: payload?.errormessage || null,
        },
      };

    //Wholesaler Week Report By Id
    case REPORT_WHOLESALER_WEEK_REPORT_BYID_REQUEST:
      return {
        ...state,
        WeekWholesalerReportsById: {
          ...defaultStatus,
          inProgress: true,
          ...payload,
        },
      };
    case REPORT_WHOLESALER_WEEK_REPORT_BYID_SUCCESS:
      return {
        ...state,
        WeekWholesalerReportsById: {
          ...defaultStatus,
          success: true,
          data: payload,
        },
      };
    case REPORT_WHOLESALER_WEEK_REPORT_BYID_FAILURE:
      return {
        ...state,
        WeekWholesalerReportsById: {
          ...defaultStatus,
          error: true,
          errormessage: payload?.errormessage || null,
        },
      };

    //Wholesaler Day Report By Id
    case REPORT_WHOLESALER_REPORT_BYID_REQUEST:
      return {
        ...state,
        viewAllWholesalerReportsById: {
          ...defaultStatus,
          inProgress: true,
          ...payload,
        },
      };
    case REPORT_WHOLESALER_REPORT_BYID_SUCCESS:
      return {
        ...state,
        viewAllWholesalerReportsById: {
          ...defaultStatus,
          success: true,
          data: payload,
        },
      };
    case REPORT_WHOLESALER_REPORT_BYID_FAILURE:
      return {
        ...state,
        viewAllWholesalerReportsById: {
          ...defaultStatus,
          error: true,
          errormessage: payload?.errormessage || null,
        },
      };

    //Wholesaler Month Report Date Search By Id
    case WHOLESALER_REPORT_MONTH_BYID_DATE_SEARCH_REQUEST:
      return {
        ...state,
        monthDateSearchWholesalerReportsById: {
          ...defaultStatus,
          inProgress: true,
          ...payload,
        },
      };
    case WHOLESALER_REPORT_MONTH_BYID_DATE_SEARCH_SUCCESS:
      return {
        ...state,
        monthDateSearchWholesalerReportsById: {
          ...defaultStatus,
          success: true,
          ...payload,
        },
      };
    case WHOLESALER_REPORT_MONTH_BYID_DATE_SEARCH_FAILURE:
      return {
        ...state,
        monthDateSearchWholesalerReportsById: {
          ...defaultStatus,
          error: true,
          errormessage: payload?.errormessage || null,
        },
      };
      case WHOLESALER_REPORT_MONTH_BYID_DATE_SEARCH_RESET:
        {
          return {
          ...state,
          monthDateSearchWholesalerReportsById: defaultStatus
          };}

    //Wholesaler Week Report Date Search By Id
    case WHOLESALER_REPORT_WEEK_BYID_DATE_SEARCH_REQUEST:
      return {
        ...state,
        weekDateSearchWholesalerReportsById: {
          ...defaultStatus,
          inProgress: true,
          ...payload,
        },
      };
    case WHOLESALER_REPORT_WEEK_BYID_DATE_SEARCH_SUCCESS:
      return {
        ...state,
        weekDateSearchWholesalerReportsById: {
          ...defaultStatus,
          success: true,
          ...payload,
        },
      };
    case WHOLESALER_REPORT_WEEK_BYID_DATE_SEARCH_FAILURE:
      return {
        ...state,
        weekDateSearchWholesalerReportsById: {
          ...defaultStatus,
          error: true,
          errormessage: payload?.errormessage || null,
        },
      };
      case WHOLESALER_REPORT_WEEK_BYID_DATE_SEARCH_RESET:
        {
          return {
          ...state,
          weekDateSearchWholesalerReportsById: defaultStatus
          };}

    //Wholesaler Day Report Date Search By Id
    case WHOLESALER_REPORT_BYID_DATE_SEARCH_REQUEST:
      return {
        ...state,
        dateSearchWholesalerReportsById: {
          ...defaultStatus,
          inProgress: true,
          ...payload,
        },
      };
    case WHOLESALER_REPORT_BYID_DATE_SEARCH_SUCCESS:
      return {
        ...state,
        dateSearchWholesalerReportsById: {
          ...defaultStatus,
          success: true,
          ...payload,
        },
      };
    case WHOLESALER_REPORT_BYID_DATE_SEARCH_FAILURE:
      return {
        ...state,
        dateSearchWholesalerReportsById: {
          ...defaultStatus,
          error: true,
          errormessage: payload?.errormessage || null,
        },
      };
      case WHOLESALER_REPORT_BYID_DATE_SEARCH_RESET:
        {
          return {
          ...state,
          dateSearchWholesalerReportsById: defaultStatus
          };}

    //Wholesaler Report Search By Id
    case REPORT_WHOLESALER_REPORT_BYID_SEARCH_REQUEST:
      return {
        ...state,
        searchWholesalerReportsById: {
          ...defaultStatus,
          inProgress: true,
          ...payload,
        },
      };
    case REPORT_WHOLESALER_REPORT_BYID_SEARCH_SUCCESS:
      return {
        ...state,
        searchWholesalerReportsById: {
          ...defaultStatus,
          success: true,
          ...payload,
        },
      };
    case REPORT_WHOLESALER_REPORT_BYID_SEARCH_FAILURE:
      return {
        ...state,
        searchWholesalerReportsById: {
          ...defaultStatus,
          error: true,
          errormessage: payload?.errormessage || null,
        },
      };

    default:
      return state;
  }
}
